<template>
    <section class="text-xs-center">
        <vimeo-player ref="player" :video-id="videoID" @ready="onReady" :player-height="height"></vimeo-player>
    </section>
</template>
<script>
export default {
    data() {
        return {
            videoID: this.$store.state.interfaceLanguage === 'pl' ? '213851498' : '223101989',
            height: 500,
            options: {},
            playerReady: false,
        };
    },
    methods: {
        onReady() {
            this.playerReady = true;
        },
        play() {
            this.$refs.player.play();
        },
        stop() {
            this.$refs.player.stop();
        },
    },
};
</script>

<style>
#vimeo-player-1 iframe {
    width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// what-is-braster.vue?7bb9ac56